<template>
  <svg
    width="484"
    height="92"
    viewBox="0 0 484 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.71874 -17.9218C51.1271 83.6759 231.595 220.336 181.205 115.757C137.944 25.9726 152.07 -6.31833 266.403 80.7092C380.736 167.737 402.808 201.996 359.547 33.4543C316.286 -135.088 393.538 -63.0241 483.15 -53.967"
      stroke="#B1A8D3"
      stroke-width="15"
    />
  </svg>
</template>
